import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

export const tapHaptic = async () => {
  try { await Haptics.impact({ style: ImpactStyle.Light }); } catch {}
};

export const successHaptic = async () => {
  try { await Haptics.impact({ style: ImpactStyle.Medium }); } catch {}
};

export const errorHaptic = async () => {
  try { await Haptics.notification({ type: NotificationType.Error }); } catch {}
};
